var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "copy-questions-modal",
            title: "Copy Questions",
            centered: "",
            "hide-footer": "",
            size: "md"
          }
        },
        [
          _c("div", { staticClass: "copy-options" }, [
            _c(
              "h5",
              {
                staticClass: "mb-3",
                staticStyle: { color: "#000000 !important" }
              },
              [
                _vm._v(
                  "\n        Choose how to copy " +
                    _vm._s(_vm.questionsSelected.length) +
                    " selected questions:\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "option-card mb-3",
                on: {
                  click: function($event) {
                    return _vm.selectCopyOption("existing")
                  }
                }
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "copy-option-card",
                    class: {
                      "border-primary": _vm.selectedCopyOption === "existing"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("b-form-radio", {
                          staticClass: "mr-3",
                          attrs: { value: "existing" },
                          model: {
                            value: _vm.selectedCopyOption,
                            callback: function($$v) {
                              _vm.selectedCopyOption = $$v
                            },
                            expression: "selectedCopyOption"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "h6",
                            {
                              staticClass: "mb-1",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Copy to Existing Templates\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Add these questions to an existing template in your account\n              "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "option-card mb-3",
                on: {
                  click: function($event) {
                    return _vm.selectCopyOption("new")
                  }
                }
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "copy-option-card",
                    class: {
                      "border-primary": _vm.selectedCopyOption === "new"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("b-form-radio", {
                          staticClass: "mr-3",
                          attrs: { value: "new" },
                          model: {
                            value: _vm.selectedCopyOption,
                            callback: function($$v) {
                              _vm.selectedCopyOption = $$v
                            },
                            expression: "selectedCopyOption"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "h6",
                            {
                              staticClass: "mb-1",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Create New Template\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Create a new template containing only these selected questions\n              "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "option-card mb-3",
                on: {
                  click: function($event) {
                    return _vm.selectCopyOption("project")
                  }
                }
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "copy-option-card",
                    class: {
                      "border-primary": _vm.selectedCopyOption === "project"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("b-form-radio", {
                          staticClass: "mr-3",
                          attrs: { value: "project" },
                          model: {
                            value: _vm.selectedCopyOption,
                            callback: function($$v) {
                              _vm.selectedCopyOption = $$v
                            },
                            expression: "selectedCopyOption"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "h6",
                            {
                              staticClass: "mb-1",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Copy to Existing Projects\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Add these questions to existing projects you have access to\n              "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "option-card mb-4",
                on: {
                  click: function($event) {
                    return _vm.selectCopyOption("newProject")
                  }
                }
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "copy-option-card",
                    class: {
                      "border-primary": _vm.selectedCopyOption === "newProject"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("b-form-radio", {
                          staticClass: "mr-3",
                          attrs: { value: "newProject" },
                          model: {
                            value: _vm.selectedCopyOption,
                            callback: function($$v) {
                              _vm.selectedCopyOption = $$v
                            },
                            expression: "selectedCopyOption"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "h6",
                            {
                              staticClass: "mb-1",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Create a New Project\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0",
                              staticStyle: { color: "#000000 !important" }
                            },
                            [
                              _vm._v(
                                "\n                Create a new project and add these questions to it\n              "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-actions d-flex justify-content-end" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-3",
                    attrs: { variant: "danger" },
                    on: { click: _vm.hideCopyModal }
                  },
                  [
                    _c("b-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: "close" }
                    }),
                    _vm._v("\n          Cancel\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "success",
                      disabled: !_vm.selectedCopyOption
                    },
                    on: { click: _vm.proceedWithCopy }
                  },
                  [
                    _c("b-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "arrow-right-circle" }
                    }),
                    _vm._v("\n          Continue\n        ")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "template-selection-modal",
            title: "Select Templates",
            centered: "",
            "hide-footer": "",
            size: "lg"
          }
        },
        [
          _c(
            "div",
            { staticClass: "template-selection" },
            [
              _vm.loadingTemplates ? _c("LoadingOverlay") : _vm._e(),
              _vm._v(" "),
              !_vm.loadingTemplates
                ? _c("div", [
                    _c(
                      "h5",
                      {
                        staticClass: "mb-3",
                        staticStyle: {
                          color: "#000000 !important",
                          "font-weight": "600"
                        }
                      },
                      [
                        _vm._v(
                          "\n          Select templates to copy " +
                            _vm._s(_vm.questionsSelected.length) +
                            " questions to:\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.availableTemplates.length === 0
                      ? _c("div", { staticClass: "text-center py-4" }, [
                          _c("p", { staticClass: "text-muted mb-0" }, [
                            _vm._v(
                              "\n            No templates available to copy to.\n          "
                            )
                          ])
                        ])
                      : _c(
                          "div",
                          { staticClass: "template-list-container" },
                          _vm._l(_vm.availableTemplates, function(
                            templateItem
                          ) {
                            return _c(
                              "div",
                              {
                                key: templateItem._id,
                                staticClass: "template-item mb-3"
                              },
                              [
                                _c("b-card", { staticClass: "template-card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-items-start" },
                                    [
                                      _c("b-form-checkbox", {
                                        staticClass: "mr-3 mt-1",
                                        attrs: {
                                          id: "template-" + templateItem._id,
                                          value: templateItem._id
                                        },
                                        model: {
                                          value: _vm.selectedTemplateIds,
                                          callback: function($$v) {
                                            _vm.selectedTemplateIds = $$v
                                          },
                                          expression: "selectedTemplateIds"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center mb-1"
                                            },
                                            [
                                              _c(
                                                "h6",
                                                { staticClass: "mb-0 mr-2" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        templateItem.name
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !templateItem.user
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        variant: "secondary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      System\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 text-muted small"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    templateItem.description ||
                                                      "No description available"
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          0
                        )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "modal-actions d-flex justify-content-between align-items-center mt-4"
                },
                [
                  _c("div", { staticClass: "selection-info" }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.selectedTemplateIds.length) +
                          " template" +
                          _vm._s(
                            _vm.selectedTemplateIds.length !== 1 ? "s" : ""
                          ) +
                          " selected\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          attrs: { variant: "light" },
                          on: { click: _vm.cancelTemplateSelection }
                        },
                        [
                          _c("b-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "arrow-left" }
                          }),
                          _vm._v("\n            Back\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "templates",
                            disabled:
                              _vm.selectedTemplateIds.length === 0 ||
                              _vm.copyingToTemplates
                          },
                          on: { click: _vm.copyQuestionsToSelectedTemplates }
                        },
                        [
                          _vm.copyingToTemplates
                            ? _c("b-spinner", {
                                staticClass: "mr-2",
                                attrs: { small: "" }
                              })
                            : _c("b-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "copy" }
                              }),
                          _vm._v(
                            "\n            Copy Questions to " +
                              _vm._s(_vm.selectedTemplateIds.length) +
                              " Template" +
                              _vm._s(
                                _vm.selectedTemplateIds.length !== 1 ? "s" : ""
                              ) +
                              "\n          "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "project-selection-modal",
            title: "Select Projects",
            centered: "",
            "hide-footer": "",
            size: "lg"
          }
        },
        [
          _c(
            "div",
            { staticClass: "project-selection" },
            [
              _vm.loadingProjects ? _c("LoadingOverlay") : _vm._e(),
              _vm._v(" "),
              !_vm.loadingProjects
                ? _c("div", [
                    _c(
                      "h5",
                      {
                        staticClass: "mb-3",
                        staticStyle: {
                          color: "#000000 !important",
                          "font-weight": "600"
                        }
                      },
                      [
                        _vm._v(
                          "\n          Select projects to copy " +
                            _vm._s(_vm.questionsSelected.length) +
                            " questions to:\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.availableProjects.length === 0
                      ? _c("div", { staticClass: "text-center py-4" }, [
                          _c("p", { staticClass: "text-muted mb-0" }, [
                            _vm._v(
                              "\n            No projects available to copy to.\n          "
                            )
                          ])
                        ])
                      : _c(
                          "div",
                          { staticClass: "project-list-container" },
                          _vm._l(_vm.availableProjects, function(projectItem) {
                            return _c(
                              "div",
                              {
                                key: projectItem._id,
                                staticClass: "project-item mb-3"
                              },
                              [
                                _c("b-card", { staticClass: "project-card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-items-start" },
                                    [
                                      _c("b-form-checkbox", {
                                        staticClass: "mr-3 mt-1",
                                        attrs: {
                                          id: "project-" + projectItem._id,
                                          value: projectItem._id
                                        },
                                        model: {
                                          value: _vm.selectedProjectIds,
                                          callback: function($$v) {
                                            _vm.selectedProjectIds = $$v
                                          },
                                          expression: "selectedProjectIds"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center mb-1"
                                            },
                                            [
                                              _c(
                                                "h6",
                                                { staticClass: "mb-0 mr-2" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(projectItem.name) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              projectItem.status === 1
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        variant: "success"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Active\n                    "
                                                      )
                                                    ]
                                                  )
                                                : projectItem.status === 2
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        variant: "secondary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Complete\n                    "
                                                      )
                                                    ]
                                                  )
                                                : projectItem.status === 3
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        variant: "warning"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      On Hold\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 text-muted small"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.stripHtml(
                                                      projectItem.description
                                                    ) ||
                                                      "No description available"
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          0
                        )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "modal-actions d-flex justify-content-between align-items-center mt-4"
                },
                [
                  _c("div", { staticClass: "selection-info" }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.selectedProjectIds.length) +
                          " project" +
                          _vm._s(
                            _vm.selectedProjectIds.length !== 1 ? "s" : ""
                          ) +
                          " selected\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          attrs: { variant: "light" },
                          on: { click: _vm.cancelProjectSelection }
                        },
                        [
                          _c("b-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "arrow-left" }
                          }),
                          _vm._v("\n            Back\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "projects",
                            disabled:
                              _vm.selectedProjectIds.length === 0 ||
                              _vm.copyingToProjects
                          },
                          on: { click: _vm.copyQuestionsToSelectedProjects }
                        },
                        [
                          _vm.copyingToProjects
                            ? _c("b-spinner", {
                                staticClass: "mr-2",
                                attrs: { small: "" }
                              })
                            : _c("b-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "copy" }
                              }),
                          _vm._v(
                            "\n            Copy Questions to " +
                              _vm._s(_vm.selectedProjectIds.length) +
                              " Project" +
                              _vm._s(
                                _vm.selectedProjectIds.length !== 1 ? "s" : ""
                              ) +
                              "\n          "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }